import { CellContext } from '@tanstack/react-table';
import classnames from 'classnames';

type Options = {
  isPercentage?: boolean;
  referenceColumn?: string;
  enableSorting?: boolean;
};

/**
 * @param {string} accessorKey 欄位key值
 * @param {string} header 欄位標題名稱
 * @param {Options?} options
 *  referenceColumn: 顏色變換參考的欄位key值,v2版本為字串,使用裡面的+,-號判斷漲跌 }
 *  isPercentage: 是否要顯示%符號
 * @returns
 */
export const colorColumn = (accessorKey: string, header: string, options?: Options) => ({
  accessorKey,
  header: () => <div className='w-full text-right'>{header}</div>,
  enableSorting: options?.enableSorting,
  cell: (props: CellContext<any, string>) => {
    const key = options?.referenceColumn || accessorKey || '';
    const percent = props?.row?.original?.[key] || '';
    const isRise = percent?.includes('+');
    const isFall = percent?.includes('-');
    const value = props.getValue() ? `${props.getValue()}${options?.isPercentage ? '%' : ''}` : '--';

    return (
      <div
        className={classnames('text-right text-sm', {
          'text-[#e03f19]': isRise,
          'text-[#208306]': isFall
        })}
        suppressHydrationWarning
      >
        {value}
      </div>
    );
  }
});
